import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor() { }

  async GetURLFormLogin(FormType: any, YearAssessment: any): Promise<any> {
    let URL = "";
    switch (FormType) {
      case "BE":
      case "B":
      case "BT":
        switch (YearAssessment) {
          case "2023":
            //URL = `https://ezlatihan.hasil.gov.my/eBE2023/index.aspx`;
            break;
          case "2022":
            URL = `https://ezlatihan.hasil.gov.my/eBE2023/index.aspx`;
            break;
          case "2021":
            URL = 'https://ezlatihan.hasil.gov.my/eBE2022/Index.aspx';
            break;
          case "2020":
            URL = 'https://ezlatihan.hasil.gov.my/eBE2021/index.aspx';
            break;
          case "2019":
            URL = 'https://ezlatihan.hasil.gov.my/eBE2021/index.aspx';
            break;
        }
        break;
      case "P":
        switch (YearAssessment) {
          case "2023":
            //URL = `https://ezlatihan.hasil.gov.my/eBE2023/index.aspx`;
            break;
          case "2022":
            URL = `https://ezlatihan.hasil.gov.my/eP2023/Index.aspx`;
            break;
          case "2021":
            URL = 'https://ezlatihan.hasil.gov.my/eP2022/Index.aspx';
            break;
          case "2020":
            URL = 'https://ezlatihan.hasil.gov.my/eP2021/Index.aspx';
            break;
        }
        break;
      case "E":
        switch (YearAssessment) {
          case "2023":
            //URL = `https://ezlatihan.hasil.gov.my/eBE2023/index.aspx`;
            break;
          case "2022":
            URL = `https://ezlatihan.hasil.gov.my/eE2023/Index.aspx`;
            break;
          case "2021":
            URL = 'https://ezlatihan.hasil.gov.my/eE2022/Index.aspx';
            break;
          case "2020":
            URL = 'https://ezlatihan.hasil.gov.my/eE2021/Index.aspx';
            break;
        }
        break;
      case "C":
        switch (YearAssessment) {
          case "2023":
            URL = `https://ezlatihan.hasil.gov.my/eC2023/Index.aspx`;
            break;
          case "2022":
            URL = `https://ezlatihan.hasil.gov.my/eC2022/Index.aspx`;
            break;
          case "2021":
            URL = 'https://ezlatihan.hasil.gov.my/eC2021/Index.aspx';
            break;
          case "2020":
            URL = 'https://ezlatihan.hasil.gov.my/eC2020/index.aspx';
            break;
        }
        break;
    }
    return URL;
  }

  async GetURLMITRS(): Promise<any> {
    //let URL = 'https://xfirelatihan.hasil.gov.my/xbrl/web/submission';
    let URL = 'https://xfire.hasil.gov.my/xbrl/web/submission';
    return URL;
  }
}
